import { render, staticRenderFns } from "./PatientReport.vue?vue&type=template&id=857607d0&scoped=true&"
import script from "./PatientReport.vue?vue&type=script&lang=js&"
export * from "./PatientReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857607d0",
  null
  
)

export default component.exports